import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458c0d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto about-section" }
const _hoisted_2 = { class: "bg-white p-4 m-4 md:p-8 md:m-8 lg:p-24 lg:m-24" }
const _hoisted_3 = { class: "mb-12" }
const _hoisted_4 = { class: "font-semibold text-base md:text-3xl mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-8" }
const _hoisted_11 = { class: "font-semibold text-base sm:text-2xl md:text-3xl mb-4" }
const _hoisted_12 = {
  href: "https://www.jlpt.jp/e/about/levelsummary.html",
  target: "_blank"
}
const _hoisted_13 = { class: "mb-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "version alpha 2.0", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Disclaimer = _resolveComponent("Disclaimer")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.t1), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.p1), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.p1_2), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.p1_3), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.p1_4), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.p1_5), 1)
        ]),
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.t2), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.p2_1) + " ", 1),
            _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.p2_2), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.p2_3), 1)
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(_ctx.p3), 1)
        ]),
        _createVNode(_component_Contact),
        _hoisted_14
      ]),
      _createVNode(_component_Disclaimer)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}